import { createContext } from 'react';
import { FsVariationToForceContextValue } from '../type';

export const fsVariationToForceContextInitialValue: FsVariationToForceContextValue = {
  fsVariationToForceState: {
    variationsToForce: {},
    variationsToForceTemp: {},
  },
  dispatchFsVariationToForce: () => {},
};

export const FsVariationToForceContext = createContext(fsVariationToForceContextInitialValue);
